const actions = {
  CHECK_AUTHORIZATION: "CHECK_AUTHORIZATION",
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGOUT: "LOGOUT",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGIN_PENDING: "LOGIN_PENDING",
  SET_ROLE: "SET_ROLE",
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (credentials) => {
    return (dispatch, getState) => {
      dispatch({
        type: actions.LOGIN_REQUEST,
        payload: credentials,
      });
    };
  },
  setRole: () => ({ type: actions.SET_ROLE }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
